import { FC } from 'react';

import { changeMode, getRecommendationAsync } from '../recommendationSlice';

import { GenericList } from '../../../shared/components/GenericList/GenericList';
import { ModeEnum, StatusEnum } from '../../../shared/models/Enums';
import { RecommendationData } from '../../../shared/models/Entities';
import { ResourcesService } from '../../../shared/services/ResourcesService';
import { selectUserLanguage } from '../../login/loginSlice';
import { useAppSelector } from '../../../app/hooks';

type RecommendationsListProps = {
    recommendations: RecommendationData[],
    recommendationStatus: StatusEnum,
    dispatch: Function
    loadRecommendationEdit: Function,
    query: string
    setQuery: Function,
    onNext: Function,
    onPrevious: Function,
};

export const RecommendationsList: FC<RecommendationsListProps> = ({
    recommendations, recommendationStatus, dispatch, loadRecommendationEdit, query, setQuery, onNext, onPrevious
}) => {
    const lang = useAppSelector(selectUserLanguage);
    const tableHeaders = ['#', ResourcesService.translate('Title', lang), ResourcesService.translate('Questions count', lang)];

    return (
        <GenericList
            lang={lang}
            h2={ResourcesService.translate('Recommendations', lang)}
            headContent={
                <tr>
                    {
                        tableHeaders.map(h => <th key={h}>{h}</th>)
                    }
                </tr>
            }
            bodyContent={
                recommendations.map((s, i) =>
                    <tr key={i} onClick={() => dispatch(getRecommendationAsync(s.id))}>
                        <td>{s.id.substring(0, 8)}...</td>
                        <td>{ResourcesService.translateInput(s.titleBg, s.titleEn, s.titleBg, lang)}</td>
                        <td>{s.questionsCount}</td>
                    </tr>
                )
            }
            listStatus={recommendationStatus}
            numberOfRows={5}
            numberOfColumns={tableHeaders.length}
            onCreateClick={() => dispatch(changeMode(ModeEnum.Create))}
            searchValue={query}
            onSearch={(value: string) => dispatch(setQuery(value))}
            onNext={() => dispatch(onNext())}
            onPrevious={() => dispatch(onPrevious())}
        />
    );
}